

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import InputText from "../../shared/input/new/InputText"
import PageTopTitle from "../../shared/PageTopTitle"
import { updateChatSubTitle } from "../../../features/aiControl/aiControlSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 30px;
            padding-top: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 50px;
        }
    }
`

const UpdateAiChatSubTitleModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {aiSubTitleData} = useSelector(state => state.aiControl)

    const [newTitle, setNewTitle] = useState(aiSubTitleData.subTitleName)

    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleClick = () => {

        if(newTitle.length > 1){
            dispatch(updateChatSubTitle({
                id: aiSubTitleData.id,
                subTitleName: newTitle
            }))
        }
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Alt Başlık Güncelle"}/>
        <div className="content">
            <InputText data={newTitle} setData={(e) => setNewTitle(e.target.value)} labelText="Alt Başlık" inputWidth={"320px"} name="addChatAiTitle"/>
            <Btn width={"200px"} bgColor="#E85446" color="#fff" handleClick={(handleClick)}>Güncelle</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default UpdateAiChatSubTitleModal